import React, { Component } from 'react'
import * as PropTypes from 'prop-types'
import { AutomationShape } from '../../../../prop-types'
import { automationOperations } from '../../../../state/ducks/automations'
import { connect } from 'react-redux'
import { BaseFormWizard } from '../../../../assets/js/base_form_wizard'
import { AutomationDataForm } from '../automation-data-form'
import { AppUI } from '../../../../assets/js/app'
import { Session } from '../../../../state/utils/session'
import { AutomationSourcesForm } from '../automation-sources-form'
import { AutomationConciliationsForm } from '../automation-conciliations-form'
import { AutomationAlarmsForm } from '../automation-alarms-form'
import { AutomationWorkerCallsForm } from '../automation-worker-calls-form'
import { AutomationValidations } from '../automation-validations'

class AutomationWizardForm extends Component {
  constructor (props) {
    super(props)

    // state
    this.state = {
      session: new Session(),
      automation: {
        cron_expression: '',
        for_all_sources: true,
        for_all_conciliations: true,
        for_all_alarms: true,
        sources: [],
        worker_calls: [],
        conciliations: [],
        alarms: [],
        stop_if_failed: false
      }
    }

    // handlers
    this.onAutomationDataChange = this.onAutomationDataChange.bind(this)
    this.sendData = this.sendData.bind(this)
    AppUI.initHelpers(['highlightjs'])
  }

  componentDidMount () {
    BaseFormWizard.init()
  }

  UNSAFE_componentWillReceiveProps (nextProps, nextContext) {
    if (nextProps.automation && 'id' in nextProps.automation) {
      this.setState({ automation: nextProps.automation })
    }
  }

  onAutomationDataChange (name, value) {
    const automation = JSON.parse(JSON.stringify(this.state.automation))
    automation[name] = value
    this.setState({
      automation
    })
  }

  sendData () {
    if (!this.props.isEditor) {
      const automation = this.state.automation
      automation.client = this.state.session.getClientSession()
      this.props.saveAutomation(this.state.automation)
    } else {
      this.props.updateAutomation(this.state.automation.id, this.state.automation)
    }
  }

  render () {
    return (
            <>
                <div className="content content-boxed">
                    <div className={' block block-themed block-opt-refresh-icon7 ' + (this.props.isLoading ? ' block-opt-refresh ' : '')}>
                        <div className="block-content">
                            {/* Simple Progress Wizard (.js-wizard-simple class is initialized in js/pages/base_forms_wizard.js) */}
                            {/* For more examples you can check out http://vadimg.com/twitter-bootstrap-wizard-example/ */}
                            <div className="js-wizard-simple block">
                                {/* Steps Progress */}
                                <div className="block-content block-content-mini block-content-full border-b">
                                    <div className="wizard-progress progress active remove-margin-b">
                                        <div className="progress-bar progress-bar-primary progress-bar-striped"
                                             role="progressbar" aria-valuenow="100" aria-valuemin="0"
                                             aria-valuemax="100"
                                             style={{ width: '0' }}>
                                        </div>
                                    </div>
                                </div>
                                {/* END Steps Progress */}

                                {/* Step Tabs */}
                                <ul className="nav nav-tabs nav-tabs-alt nav-justified">
                                    <li className="active">
                                        <a href="#simple-progress-step1" data-toggle="tab">1. Automation Data</a>
                                    </li>
                                    <li className="">
                                        <a href="#simple-progress-step2" data-toggle="tab">2. Sources</a>
                                    </li>
                                    <li className="">
                                        <a href="#simple-progress-step3" data-toggle="tab">3. Conciliations</a>
                                    </li>
                                    <li className="">
                                        <a href="#simple-progress-step4" data-toggle="tab">4. Alarms</a>
                                    </li>
                                    <li className="">
                                        <a href="#simple-progress-step5" data-toggle="tab">5. Worker Calls</a>
                                    </li>
                                    <li className="">
                                        <a href="#simple-progress-step6" data-toggle="tab">6. Validations</a>
                                    </li>

                                </ul>
                                {/* END Step Tabs */}

                                {/* Form */}
                                <form className="form-horizontal" action="javascript:void(0)">
                                    {/* Steps Content */}
                                    <div className="block-content tab-content" style={{ minHeight: '300px' }}>
                                        {/* Step 1 */}
                                        <div className="tab-pane fade fade-right in push-30-t push-50 active"
                                             id="simple-progress-step1">
                                            <AutomationDataForm
                                                automation={this.state.automation}
                                                onChange={this.onAutomationDataChange}
                                            />
                                        </div>
                                        {/* END Step 1 */}

                                        {/* Step 2 */}
                                        <div className="tab-pane fade fade-right in push-30-t push-50"
                                             id="simple-progress-step2">
                                            <AutomationSourcesForm
                                                automation={this.state.automation}
                                                onChange={this.onAutomationDataChange}
                                            />
                                        </div>
                                        {/* END Step 2 */}

                                        {/* Step 3 */}
                                        <div className="tab-pane fade fade-right in push-30-t push-50"
                                             id="simple-progress-step3">
                                            <AutomationConciliationsForm
                                                automation={this.state.automation}
                                                onChange={this.onAutomationDataChange}
                                            />
                                        </div>
                                        {/* END Step 3 */}

                                        {/* Step 4 */}
                                        <div className="tab-pane fade fade-right in push-30-t push-50"
                                             id="simple-progress-step4">
                                            <AutomationAlarmsForm
                                                automation={this.state.automation}
                                                onChange={this.onAutomationDataChange}
                                            />
                                        </div>
                                        {/* END Step 4 */}

                                        {/* Step 5 */}
                                        <div className="tab-pane fade fade-right in push-30-t push-50"
                                             id="simple-progress-step5">
                                            <AutomationWorkerCallsForm
                                                automation={this.state.automation}
                                                onChange={this.onAutomationDataChange}
                                            />
                                        </div>
                                        {/* END Step 5 */}
                                         {/* Step 6 */}
                                         <div className="tab-pane fade fade-right in push-30-t push-50"
                                             id="simple-progress-step6">
                                            <AutomationValidations
                                                automation={this.state.automation}
                                                onChange={this.onAutomationDataChange}
                                            />
                                        </div>
                                        {/* END Step 6 */}
                                    </div>
                                    {/* END Steps Content */}

                                    {/* Steps Navigation */}
                                    <div className="block-content block-content-mini block-content-full border-t">
                                        <div className="row">
                                            {
                                                this.props.saveAutomationErrorResponse.error
                                                  ? <div className="col-xs-12 text-danger text-center">
                                                        {JSON.stringify(this.props.saveAutomationErrorResponse.error)}
                                                    </div>
                                                  : null
                                            }
                                            {
                                                this.props.updateAutomationErrorResponse.error
                                                  ? <div className="col-xs-12 text-danger text-center">
                                                        {JSON.stringify(this.props.updateAutomationErrorResponse.error)}
                                                    </div>
                                                  : null
                                            }
                                            <div className="col-xs-6">
                                                <button
                                                    className="wizard-prev btn btn-warning"
                                                    type="button"
                                                >
                                                    <i className="fa fa-arrow-circle-o-left"></i> Previous
                                                </button>
                                            </div>
                                            <div className="col-xs-6 text-right">
                                                <button
                                                    className="wizard-next btn btn-success"
                                                    type="button"
                                                >
                                                    Next <i className="fa fa-arrow-circle-o-right"></i>
                                                </button>
                                                <button
                                                    className="wizard-finish btn btn-primary"
                                                    type="button"
                                                    disabled={this.props.isLoading}
                                                    onClick={this.sendData}
                                                >
                                                    {
                                                        this.props.isLoading
                                                          ? <>
                                                                <i className="ml-1 fa fa-spinner fa-spin pull-right"></i>
                                                                <span>Submit</span>
                                                            </>
                                                          : <>
                                                                <i className="ml-1 si si-login pull-right"></i>
                                                                <span>Submit</span>
                                                            </>
                                                    }
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    {/* END Steps Navigation */}
                                </form>
                                {/* END Form */}
                            </div>
                            {/* END Simple Progress Wizard */}
                            {/* <pre className="pre-sh push"> */}
                            {/*    <code className="json"> */}
                            {/*    {JSON.stringify(this.state.automation)} */}
                            {/*    </code> */}
                            {/* </pre> */}
                        </div>
                    </div>
                </div>
            </>
    )
  }
}

// Set propTypes
AutomationWizardForm.propTypes = {
  automation: AutomationShape,
  saveAutomationErrorResponse: PropTypes.object,
  updateAutomationErrorResponse: PropTypes.object,
  isEditor: PropTypes.bool
}

// Set defaultProps
AutomationWizardForm.defaultProps = {
  automation: {},
  saveAutomationErrorResponse: {},
  updateAutomationErrorResponse: {},
  isEditor: false
}

// mapStateToProps
const mapStateToProps = (state) => ({
  isLoading: state.automations.saveAutomationReducer.loading || state.automations.updateAutomationReducer.loading,
  saveAutomationErrorResponse: state.automations.saveAutomationReducer.error_data,
  updateAutomationErrorResponse: state.automations.updateAutomationReducer.error_data
})

// mapStateToProps
const mapDispatchToProps = {
  saveAutomation: automationOperations.save,
  updateAutomation: automationOperations.update
}

// Export Class
const _AutomationWizardForm = connect(mapStateToProps, mapDispatchToProps)(AutomationWizardForm)
export { _AutomationWizardForm as AutomationWizardForm }
